class MotPresidentController {

  constructor() {
  }

}

MotPresidentController.$inject = [];

module.exports = MotPresidentController;



// WEBPACK FOOTER //
// ./src/app/components/mot-president/mot-president.controller.js